import { Box, Text } from '@mantine/core';
import { useMemo } from 'react';

import { RelatedResource } from '@e-origin/shared';

import { viewIcon } from '@assets';
import { Table, TableActions, TableColumnProps } from '@components';
import { IdentificationStatusIcon } from './IdentificationStatusIcon';

export interface ImporterViewIdentificationProps {
  importer: any;
}

interface IdentificationDocument extends RelatedResource {
  document: string;
  type: string;
}

export const ImporterViewIdentification: React.FC<ImporterViewIdentificationProps> = ({ importer }) => {
  const importerDocumentsList = useMemo<IdentificationDocument[]>(
    () =>
      [
        { document: 'ID Card', type: 'ID_CARD', relatedResource: importer?.idCard.relatedResources[0] },
        {
          document: 'Chinese business license',
          type: 'BUSINESS_LICENSE',
          relatedResource: importer?.businessLicense.relatedResources[0],
        },
        { document: 'EORI certificate', type: 'EORI', relatedResource: importer?.eori.relatedResources[0] },
        { document: 'VAT certificate', type: 'VAT', relatedResource: importer?.vat.relatedResources[0] },
        {
          document: 'Tax return paperwork',
          type: 'TAX',
          relatedResource: importer?.taxReturn?.relatedResources[0],
        },
      ].map((doc) => ({
        document: doc.document,
        type: doc.type,
        ...doc.relatedResource,
      })),
    [importer],
  );

  const columns: TableColumnProps<IdentificationDocument>[] = [
    {
      name: 'Identification document',
      cell: (row) => <Text fz={13}>{row.document}</Text>,
      sortable: false,
    },
    {
      name: 'File name',
      cell: (row) => <Text fz={13}>{row.fileName}</Text>,
    },
    {
      name: 'Format',
      cell: (row) => <Text fz={13}>{row.mediaType?.toUpperCase()}</Text>,
    },
    {
      name: 'Status',
      cell: (row) => <IdentificationStatusIcon key={row.type} rowData={row} />,
    },
    {
      name: 'Actions',
      sticky: 'right',
      cell: (row) => (
        <TableActions
          actions={[
            {
              icon: viewIcon,
              text: 'Download',
              onClick: () => {
                window.open(row.signedUrl, '_blank');
              },
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Box mt={20}>
      <Table columns={columns} dataSource={importerDocumentsList} pagination verticalSpacing="xs" />
    </Box>
  );
};
